import React, { useRef } from "react";
import {
  Autocomplete,
  GoogleMap,
  useJsApiLoader,
} from "@react-google-maps/api";

const libraries = ["places"];

export function NuevoViaje5() {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAMqRtQO0710z-o3NJGNXZtCpfUBObWJe4",
    libraries,
  });
  const mapRef = useRef();
  const autocompleteRef = useRef();

  const containerStyle = {
    width: "100%",
    height: "400px",
  };

  const inputStyle = {
    boxSizing: "border-box",
    border: "1px solid transparent",
    width: "240px",
    height: "38px",
    padding: "0 12px",
    borderRadius: "3px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
    fontSize: "14px",
    outline: "none",
    textOverflow: "ellipses",
    position: "absolute",
    right: "8%",
    top: "11px",
    marginLeft: "-120px",
  };

  const center = {
    lat: 28.626137,
    lng: 79.821603,
  };

  const onLoadMap = (map) => {
    mapRef.current = map;
  };

  const onLoadAutocomplete = (autocomplete) => {
    autocompleteRef.current = autocomplete;
  };

  const handlePlaceChanged = () => {
    const { geometry } = autocompleteRef.current.getPlace();
    const bounds = new window.google.maps.LatLngBounds();
    if (geometry.viewport) {
      bounds.union(geometry.viewport);
    } else {
      bounds.extend(geometry.location);
    }
    mapRef.current.fitBounds(bounds);
  };

  return (
    <div>
      {isLoaded && (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          onLoad={onLoadMap}
          zoom={10}
        >
          <Autocomplete
            onLoad={onLoadAutocomplete}
            onPlaceChanged={handlePlaceChanged}
          >
            <input
              type="text"
              placeholder="Search Location"
              style={inputStyle}
            />
          </Autocomplete>
        </GoogleMap>
      )}
    </div>
  );
}
